<div class="container pt-3 fade-in-left" id="centerFrame">
    <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
        <a (click)="back()"><div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div></a>
        <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center ">{{ operacion }}Comercio</h1></div>
    </div>

    <div class="row filters fade-in tag-row" *ngIf="id">
        <div class="col filter" [ngClass]="{'filter-selected': showList == 'perfil'}" (click)="selectFilter('perfil')" id="infoPerfil">Perfil</div>
        <div class="col filter" [ngClass]="{'filter-selected': showList == 'detalle'}" (click)="selectFilter('detalle')" id="infoDetalle">Detalle</div>
        <div class="col filter" [ngClass]="{'filter-selected': showList == 'ubicaciones'}" (click)="selectFilter('ubicaciones')" id="infoUbicaciones">Ubicaciones</div>
        <div class="col filter" [ngClass]="{'filter-selected': showList == 'productos'}" (click)="selectFilter('productos')" id="infoProductos">Productos</div>
    </div>

    <div class="row mt-2 mb-2" *ngIf="id">
        <div class="col">
            <small class="text-muted">
                Creado: {{ d_fecha_creacion | date:'dd/MM/yyyy HH:mm' }} hs
                <ng-container *ngIf="d_fecha_modificacion">
                    &nbsp;·&nbsp;Última modificación: {{ d_fecha_modificacion | date:'dd/MM/yyyy HH:mm' }} hs
                    <ng-container *ngIf="x_modificado_por">&nbsp;por {{ x_modificado_por }}</ng-container>
                </ng-container>
            </small>
        </div>
    </div>

    <!-- Sections -->
    <div class="hiddenList" [ngClass]="{'showlist': showList == 'perfil'}">
        <div class="row-cols-12 m-2">
            <div class="text-p p-3">
                <div class="col file fileuploadphoto text-center">
                    @if (!preview_img_avatar()) {
                        <img src="./assets/img/user-init.png" style="width:80px" class="text-end rounded-circle business-profile">
                    } @else {
                        <img [src]="preview_img_avatar()" style="width:80px" class="text-end rounded-circle business-profile imagen-preview" (click)="openModal()">
                    }
                    <input type="file" #profileimage class="form-control input-image" id="profileimage" style="display: none;" (change)="capturarFileImgAvatar()">
                    <label class="changeimage" (click)="capturarFileImgAvatar()">cambiar</label>
                </div>
            </div>    
        </div>
        <!-- Modal Previw IMG PERFIL :: INICIO -->
        <div class="modal fade" id="modalPreviewImg" tabindex="-1" role="dialog" aria-labelledby="modalPreviewImgLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="modalPreviewImgLabel">Foto Perfil</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <img [src]="preview_img_avatar_large()" class="img-fluid">
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                </div>
                </div>
            </div>
        </div>
        <!-- Modal Previw IMG PERFIL :: FIN -->
        <div class="row-cols-12 m-2 mt-0">
            <div class="row p-3 mb-0 align-items-center">
                <div class="mb-3 mt-0 text-start ">
                    <form (ngSubmit)="saveUsuario()" [formGroup]="moreUsuario">
                        <div class="mb-4 mt-2 text-start ">
                            <label for="perfil" class="form-label">Perfil</label>
                            <select class="form-control" name="perfil" formControlName="perfil" >
                                <option *ngFor="let perfil of perfiles" [ngValue]="perfil.id">{{ perfil.x_descripcion }}</option>
                            </select>
                        </div>
                        <div class="mb-4 mt-2 text-start ">
                            <label for="email" class="form-label"><b>Email</b></label>
                            <input type="email" class="form-control" id="email" formControlName="email" placeholder="Ingrese un email" [attr.disabled]="id!==''">
                            @if (moreUsuario.controls['email'].invalid && (moreUsuario.controls['email'].dirty || moreUsuario.controls['email'].touched) && moreUsuario.controls['email'].errors?.['required']) {
                                <div class="alert-danger" role="alert"><small class="alert">El email es requerido</small></div>
                            }
                        </div>
                        <div class="mb-4 mt-2 text-start ">
                            <label for="password" class="form-label"><b>Password</b></label>
                            <div class="password-field">
                                <input [type]="fieldTextType ? 'text' : 'password'" class="form-control" id="password" formControlName="password" placeholder="Ingrese un password">
                                <i  class="bi seePassword"
                                    [ngClass]="{
                                    'bi-eye-slash': !fieldTextType,
                                    'bi-eye': fieldTextType
                                    }"
                                    (click)="toggleFieldTextType()"
                                ></i>
                            </div>
                            @if (moreUsuario.controls['password'].invalid && (moreUsuario.controls['password'].dirty || moreUsuario.controls['password'].touched) && moreUsuario.controls['password'].errors?.['required']) {
                                <div class="alert-danger" role="alert"><small class="alert">El password es requerido</small></div>
                            }
                        </div>
                        <div class="mb-4 mt-2 text-start">
                            <label for="repetir_password" class="form-label"><b>Repetir Password</b></label>
                            <div class="password-field">
                                <input [type]="fieldTextType ? 'text' : 'password'" class="form-control" id="repetir_password" formControlName="repetir_password" placeholder="Repita el password">
                                <i  class="bi seePassword"
                                    [ngClass]="{
                                    'bi-eye-slash': !fieldTextType,
                                    'bi-eye': fieldTextType
                                    }"
                                    (click)="toggleFieldTextType()"
                                ></i>
                            </div>
                            @if (moreUsuario.controls['repetir_password'].invalid && (moreUsuario.controls['repetir_password'].dirty || moreUsuario.controls['repetir_password'].touched) && moreUsuario.controls['repetir_password'].errors?.['required']) {
                                <div class="alert-danger" role="alert"><small class="alert">El repetir password es requerido</small></div>
                            }
                        </div>
                        
                        <div class="mb-4 mt-2 text-start">
                            <label for="porcentaje_comision" class="form-label"><b>% de comisión</b> en Libre Salud</label>
                            <input type="text" class="form-control" id="porcentaje_comision" formControlName="porcentaje_comision" [mask]="'separator.2'" [suffix]="'%'" [dropSpecialCharacters]="true" [thousandSeparator]="''" [decimalMarker]="'.'" placeholder="0.00%">
                            @if (moreUsuario.controls['porcentaje_comision'].invalid || (moreUsuario.controls['porcentaje_comision'].dirty || moreUsuario.controls['porcentaje_comision'].touched) && moreUsuario.controls['porcentaje_comision'].errors?.['required']) {
                                <div class="alert-danger" role="alert"><small class="alert">Ingrese un % de comisión válido</small></div>
                            }
                        </div>

                        <div class="mp-status-card mt-4">
                            <div class="mp-status-icon" [class.connected]="mercadoPagoConectado()">
                                <i class="bi" [ngClass]="mercadoPagoConectado() ? 'bi-check-circle' : 'bi-x-circle'"></i>
                            </div>

                            <div class="mp-status-content">
                                <div class="mp-status-title">
                                    Mercado Pago
                                </div>

                                <div class="mp-status-detail">
                                    @if (mercadoPagoConectado()) {
                                        Cuenta conectada
                                        @if (mercadoPagoVencimiento()) {
                                            <span> · vence {{ mercadoPagoVencimiento() }}</span>
                                        }
                                    } @else {
                                        Cuenta no conectada
                                    }
                                </div>
                            </div>
                        </div>
                        @if (error()) {
                            <div class="alert alert-danger mt-2" role="alert">
                                <small>{{ error() }}</small>
                            </div>
                        }
                        <div class="d-grid mt-5 mb-2">
                            <button type="submit" class="btn btn-primary btn-lg mt-0" [disabled]="loading()">{{(loading()) ? 'Cargando...' : botonOperacion+'Comercio'}}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="hiddenList" [ngClass]="{'showlist': showList == 'detalle'}">
        <div class="row-cols-12 m-2 mt-0">
            <div class="row p-3 mb-0 align-items-center">
                <div class="mb-3 mt-0 text-start ">
                    <form (ngSubmit)="saveUsuarioDetalle()" [formGroup]="myAccountIdentidad">
                        <div class="row mt-4">
                            <label for="razon_social" class="form-label">Razón Social</label>
                            <input type="text" class="form-control" id="razon_social" formControlName="razon_social">
                            @if (myAccountIdentidad.controls['razon_social'].invalid && (myAccountIdentidad.controls['razon_social'].dirty || myAccountIdentidad.controls['razon_social'].touched) && myAccountIdentidad.controls['razon_social'].errors?.['required']) {
                                <div class="alert-danger" role="alert"><small class="alert">La razón social es requerida</small></div>
                            }
                        </div>
                        <div class="row mt-4">
                            <label for="nombre_fantasia" class="form-label">Nombre Fantasía</label>
                            <input type="text" class="form-control" id="nombre_fantasia" formControlName="nombre_fantasia">
                            @if (myAccountIdentidad.controls['nombre_fantasia'].invalid && (myAccountIdentidad.controls['nombre_fantasia'].dirty || myAccountIdentidad.controls['nombre_fantasia'].touched) && myAccountIdentidad.controls['nombre_fantasia'].errors?.['required']) {
                                <div class="alert-danger" role="alert"><small class="alert">El nombre fantasía es requerido</small></div>
                            }
                        </div>
                        <div class="row mt-4 mb-4">
                            <div class="col">
                                <label for="tipo_documento" class="form-label">Tipo</label>
                                <select class="form-control" formControlName="tipo_documento" (change)="actualizarMascara()">
                                    @for (td of tiposDocumentos(); track td.id) {
                                        <option [ngValue]="td.id">{{ td.x_descripcion }}</option>
                                    }
                                </select>
                            </div>
                            <div class="col">
                                <label for="nro_documento" class="form-label">Documento</label>
                                <div class="position-relative">
                                    <input
                                        type="text"
                                        class="form-control"
                                        formControlName="nro_documento"
                                        [mask]="maskDocumento()"
                                        [showMaskTyped]="true"
                                        placeholder="DNI / CUIT / CUIL"
                                    />
                                    @if (isCheckingDni()) {
                                        <span class="spinner-border spinner-border-sm text-secondary dni-spinner" role="status" aria-hidden="true"></span>
                                    }
                                </div>
                            </div>
                        </div>
                        @if (asociadoCardio()) {
                            <div class="row m-3 pt-2 pb-2 pr-1 pl-1 align-items-center" id="tooltip-pwa">
                                <div class="col-auto"><img src="./assets/img/logo-cardio.svg" class="img-asociado"></div>
                                <div class="col" id="helpinfo">Asociado a <b>Cardio 24hs</b></div>
                            </div>
                        }
                        @if (myAccountIdentidad.controls['tipo_documento'].invalid && (myAccountIdentidad.controls['tipo_documento'].dirty || myAccountIdentidad.controls['tipo_documento'].touched) && myAccountIdentidad.controls['tipo_documento'].errors?.['required']) {
                            <div class="alert-danger" role="alert"><small class="alert">El Tipo de Documento es requerido</small></div>
                        }
                        @if (myAccountIdentidad.controls['nro_documento'].invalid && (myAccountIdentidad.controls['nro_documento'].dirty || myAccountIdentidad.controls['nro_documento'].touched) && myAccountIdentidad.controls['nro_documento'].errors?.['required']) {
                            <div class="alert-danger" role="alert"><small class="alert">Ingrese un Nro. de Documento válido</small></div>
                        }
                        @if (myAccountIdentidad.controls['nro_documento'].errors?.['maxlength']) {
                            <div class="alert-danger" role="alert"><small class="alert">El número de documento no puede tener más de 13 caracteres.</small></div>
                        }
                        <div class="row mt-4">
                            <label for="nro_habilitacion" class="form-label">Nro de habilitación</label>
                            <input type="text" class="form-control" id="nro_habilitacion" formControlName="nro_habilitacion">
                            @if (myAccountIdentidad.controls['nro_habilitacion'].invalid && (myAccountIdentidad.controls['nro_habilitacion'].dirty || myAccountIdentidad.controls['nro_habilitacion'].touched) && myAccountIdentidad.controls['nro_habilitacion'].errors?.['required']) {
                                <div class="alert-danger" role="alert"><small class="alert">Ingrese un Nro. de habilitación válido</small></div>
                            }
                        </div>
                        <div class="row mt-4">
                            <label for="responsable_comercial" class="form-label">Responsable Técnico / Comercial</label>
                            <input type="text" class="form-control" id="responsable_comercial" formControlName="responsable_comercial">
                            @if (myAccountIdentidad.controls['responsable_comercial'].invalid && (myAccountIdentidad.controls['responsable_comercial'].dirty || myAccountIdentidad.controls['responsable_comercial'].touched) && myAccountIdentidad.controls['responsable_comercial'].errors?.['required']) {
                                <div class="alert-danger" role="alert"><small class="alert">El responsable técnico / comercial es requerido</small></div>
                            }
                        </div>
                        <div class="row mt-4">
                            <div class="align-items-center form-switch ps-0 d-flex align-items-center justify-content-between">
                                <label class="form-check-label col col-sm-4 pe-5" for="mercadopago">Acepta MercadoPago</label>
                                <input class="form-check-input ms-3" type="checkbox" id="mercadopago" formControlName="mercadopago">
                            </div>
                        </div>
    
                        <div class="row mt-4 ">
                            <div class=" align-items-center form-switch ps-0 d-flex align-items-center justify-content-between">
                                <label class="form-check-label col col-sm-4 pe-5" for="envios">Realiza envíos</label>
                                <input class="form-check-input ms-3" type="checkbox" formControlName="envios">
                            </div>
                        </div>
    
                        <div class="row mt-4 ">
                            <div class=" align-items-center form-switch ps-0 d-flex align-items-center justify-content-between">
                                <label class="form-check-label col col-sm-4 pe-5" for="vende_medicamentos">Vende medicamentos</label>
                                <input class="form-check-input ms-3" type="checkbox" formControlName="vende_medicamentos">
                            </div>
                        </div>
                        <div class="row mt-4">
                            <label for="porcentaje_descuento_medicamentos" class="form-label"><b>% de descuento</b> en medicamentos</label>
                            <input type="text" class="form-control" id="porcentaje_descuento_medicamentos" formControlName="porcentaje_descuento_medicamentos" [mask]="'separator.2'" [suffix]="'%'" [dropSpecialCharacters]="true" [thousandSeparator]="''" [decimalMarker]="'.'" placeholder="0.00%">
                            @if (myAccountIdentidad.controls['porcentaje_descuento_medicamentos'].invalid || (myAccountIdentidad.controls['porcentaje_descuento_medicamentos'].dirty || myAccountIdentidad.controls['porcentaje_descuento_medicamentos'].touched) && myAccountIdentidad.controls['porcentaje_descuento_medicamentos'].errors?.['required']) {
                                <div class="alert-danger" role="alert"><small class="alert">Ingrese un % de descuento válido</small></div>
                            }
                        </div>
                        @if (error()) {
                            <div class="alert alert-danger mt-2" role="alert">
                                <small>{{ error() }}</small>
                            </div>
                        }
                        <div class="d-grid mt-4 mb-3 pb-3">
                            <button type="submit" class="btn btn-primary btn-lg mt-0" [disabled]="loading()">{{(loading()) ? 'Cargando...' : botonOperacion+'Comercio'}}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="hiddenList" [ngClass]="{'showlist': showList == 'ubicaciones'}">
        <div class="row-cols-12 m-2 mt-3">
            <div class="section-header">
                <div class="section-title">Ubicaciones</div>
                <div class="section-subtitle">
                    {{ ubicacionesComercio().length }} ubicaciones cargadas
                </div>
            </div>

            @for (ubicacion of ubicacionesComercio(); track ubicacion.id) {
                <div class="info-card">
                    <div class="info-icon">
                        <i class="bi bi-geo-alt"></i>
                    </div>

                    <div class="info-content">
                        <div class="info-title">
                            {{ ubicacion.x_domicilio || 'Sin domicilio' }}
                        </div>

                        @if (ubicacion.x_piso_dpto) {
                            <div class="info-subtitle">
                                {{ ubicacion.x_piso_dpto }}
                            </div>
                        }

                        <div class="info-extra">
                            @if (ubicacion.x_codigo_postal) {
                                <span>CP: {{ ubicacion.x_codigo_postal }}</span>
                            }

                            @if (ubicacion.x_telefono) {
                                <span class="ms-2">Tel: {{ ubicacion.x_telefono }}</span>
                            }
                        </div>

                        @if (ubicacion.b_default) {
                            <div class="default-badge">Principal</div>
                        }
                    </div>
                </div>
            } @empty {
                <div class="empty-card">
                    Este comercio todavía no tiene ubicaciones cargadas.
                </div>
            }

        </div>
    </div>
    <div class="hiddenList" [ngClass]="{'showlist': showList == 'productos'}">
        <div class="row-cols-12 m-2 mt-3">
            <div class="section-header">
                <div class="section-title">Productos</div>
                <div class="section-subtitle">
                    {{ productosComercio().length }} productos cargados
                </div>
            </div>

            @for (producto of productosComercio(); track producto.id) {
                <div class="info-card">
                    @if (producto.x_img_producto) {
                        <img
                            class="product-thumb"
                            [src]="API_URI + 'uploads/images/' + producto.x_img_producto"
                            [alt]="producto.x_nombre || 'Producto'"
                        />
                    } @else {
                        <div class="info-icon">
                            <i class="bi bi-box-seam"></i>
                        </div>
                    }

                    <div class="info-content">
                        <div class="info-title">
                            {{ producto.x_nombre || 'Producto sin nombre' }}
                        </div>

                        @if (producto.x_descripcion) {
                            <div class="info-subtitle">
                                {{ producto.x_descripcion }}
                            </div>
                        }

                        <div class="info-extra">
                            @if (producto.n_precio) {
                                <span>$ {{ producto.n_precio | number:'1.0-0' }}</span>
                            }

                            @if (producto.x_sku) {
                                <span class="ms-2">SKU: {{ producto.x_sku }}</span>
                            }
                        </div>

                        @if (producto.n_porcentaje_descuento) {
                            <div class="default-badge">
                                {{ producto.n_porcentaje_descuento }}% OFF
                            </div>
                        }
                    </div>
                </div>
            } @empty {
                <div class="empty-card">
                    Este comercio todavía no tiene productos cargados.
                </div>
            }
        </div>
    </div>
</div>